//<Campaigns>
export const CAMPAIGNS = '/campaigns';

export const CAMPAIGNS_CAMPAIGNS_GET = CAMPAIGNS + '/list';
export const CAMPAIGNS_CAMPAIGNS_SIMILAR_GET = (programID: number) => CAMPAIGNS + `/${programID}` + '/related';
export const CAMPAIGNS_CAMPAIGNS_SPECIAL_GET = CAMPAIGNS + '/special_campaigns';
export const CAMPAIGNS_FILTERS_GET = CAMPAIGNS + '/filters';

//<Campaigns>

//<Lockers>
export const CPA_LOCKER = '/offer_locker';

//#cpa-locker
export const CPA_LOCKER_CREATE = CPA_LOCKER + '/create';
export const CPA_LOCKER_EDIT = (lockerId: string) => CPA_LOCKER + `/${lockerId}` + '/edit';
export const CPA_LOCKER_CAMPAIGN_DETAILS_GET = (campaignId: number) => CPA_LOCKER + '/campaign' + `/${campaignId}` + '/details';

//#available-campaigns
export const CPA_LOCKER_CAMPAIGNS_AVAILABLE_GET = CPA_LOCKER + '/campaign/index';
export const CPA_LOCKER_CAMPAIGNS_AVAILABLE_FILTERS_GET = CPA_LOCKER + '/campaign/filters';

//#cpa-locker-campaigns
export const CPA_LOCKER_CAMPAIGNS_GET = (lockerId: string) => CPA_LOCKER + `/${lockerId}` + '/campaign' + '/index';
export const CPA_LOCKER_CAMPAIGNS_FILTERS_GET = (lockerId: string) => CPA_LOCKER + `/${lockerId}` + '/campaign' + '/filters';

export const CPA_LOCKER_CAMPAIGNS_REJECT_ALL = (lockerId: string) => CPA_LOCKER + `/${lockerId}` + '/campaign/reject-all';
export const CPA_LOCKER_CAMPAIGNS_ADD_ALL = (lockerId: string) => CPA_LOCKER + `/${lockerId}` + '/campaign/add-all';
export const CPA_LOCKER_CAMPAIGNS_UPDATE_DECISION = (lockerId: string) => CPA_LOCKER + `/${lockerId}` + '/campaign/update-decision';

//#offer_api
const OFFER_API = '/offer_locker/offer_api';
export const OFFER_API_APPLICATION = OFFER_API + '/application';

const LOCKER = '/locker';
export const OFFER_API_LOCKER_TOKEN = OFFER_API + LOCKER + '/token';
export const OFFER_API_STORE_LOCKER_TOKEN = OFFER_API_LOCKER_TOKEN + '/store';
export const OFFER_API_GET_LOCKER_DOMAINS = OFFER_API + LOCKER + '/get-domains';

const OFFERWALL = '/offerwall';
export const OFFER_API_OFFERWALL_TOKEN = OFFER_API + OFFERWALL + '/token';
export const OFFER_API_STORE_OFFERWALL_TOKEN = OFFER_API_OFFERWALL_TOKEN + '/store';
export const OFFER_API_GET_OFFERWALL_DOMAINS = OFFER_API + OFFERWALL + '/get-domains';
//<Lockers>

//Payments

export const PAYMENTS = '/payments';

export const WITHDRAWAL_INFORMATION_GET = PAYMENTS + '/withdrawal-information';
//<Feedback>

export const FEEDBACK = '/feedback';

export const FEEDBACK_USER_STORE = FEEDBACK + '/user';

//<Feedback>
